import easelAPI, { getOptions, EaselResponse } from 'apis/helpers/easelAPI'

export const getArtworkDetails = async ({
  artistId,
  artworkId,
}: Record<string, any>): Promise<EaselResponse> => {
  const options = getOptions
  const json = await easelAPI.fetchJSON({
    name: 'getArtworkDetails',
    options,
    url: `/artwork/${artistId}/${artworkId}`,
  })
  return json
}

export const incrementViewCount = async (artworkId: number): Promise<EaselResponse> => {
  const options = getOptions
  const json = await easelAPI.fetchJSON({
    name: 'incrementViewCount',
    options,
    url: `/artwork/${artworkId}/ivc`,
  })
  return json
}
